<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="广告观看记录详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">观看人:</el-col>
        <el-col :span="19">
          <el-avatar shape="square" :size="32" :src="showForm.basic.profile.avatar"></el-avatar>
          <div>{{ showForm.basic.profile.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">设备标题:</el-col>
        <el-col :span="19">{{ showForm.basic.deviceTitle }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">广告标题:</el-col>
        <el-col :span="19">{{ showForm.basic.advertiseTitle }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">观看时长:</el-col>
        <el-col :span="19">
          {{ showForm.basic.duration }}秒
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">观看时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { findAdvertiseRecord } from '@/api/alfmeier'
export default {
  name: 'AlfmeierAdertiseRecordDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const advertiseRecordId = row.advertiseRecordId
      this.row = row
      const data = await findAdvertiseRecord({
        advertiseRecordId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
